module.exports = __webpack_public_path__ + "static/media/objectives.aed9ca12.md";